//印语
export default {
    首页:"halaman Depan",
我的资产:"aset saya",
重置登录密码:"Setel ulang kata sandi masuk",
重置登录密码后:"Setelah mengatur ulang kata sandi login, penarikan mata uang dan transfer OTC dilarang dalam waktu 24 jam.",
请选择:"tolong pilih",
密码在:"Kata sandi terdiri dari 6-16 karakter dan terdiri dari angka dan huruf",
请确认密码:"Harap konfirmasi kata sandi Anda",
产品列表:"Daftar Produk",
币种:"Mata uang",
期限:"syarat",
订单列表:"Daftar Pesanan",
交易用:"Untuk perdagangan",
立即入金开始您的第一笔交易:"Setor uang sekarang untuk memulai perdagangan pertama Anda",
立即入金:"Setor sekarang",
币种对:"pasangan mata uang",
涨幅:"Meningkatkan",
交易量:"Volume perdagangan",
欢迎登录:"Silakan masuk",
登录:"Gabung",
新用户注册:"pendaftaran pengguna baru",
总资产折合:"Total aset dikonversi",
冻结:"membekukan",
折合:"dikonversi",
充值币种:"Isi ulang mata uang",
充值数量:"Kuantitas isi ulang",
确认信息:"Konfirmasikan informasi",
充币网络:"Jaringan simpanan",
欢迎注册:"Selamat mendaftar",
点击打开:"Klik untuk membuka",
这是一段信息:"Ini adalah sebuah informasi",
提币数量:"Jumlah koin yang ditarik",
提币:"Tarik koin",

百万用户首选:"Pilihan pertama jutaan pengguna",
小时成交量:"Volume perdagangan 24 jam",
优质数字资产:"Aset digital berkualitas tinggi",
我们的核心产品:"Produk inti kami",
你可以选择丰富的交易方式:"Anda dapat memilih dari berbagai metode perdagangan",
现货:"Barang spot",
我们提供:"kami menyediakan",
币种的交易服务:"Layanan perdagangan mata uang",
合约:"kontrak",
使用合约丰富你的交易体验:"Gunakan kontrak untuk memperkaya pengalaman perdagangan Anda",
赚币:"Hasilkan koin",
行业内领先收益:"Pendapatan terdepan di industri",
多元化的产品服务:"Produk dan layanan yang terdiversifikasi",
选择更多:"Pilih lebih banyak layanan dan jelajahi kemungkinan tanpa batas",
福利中心:"Pusat kesejahteraan",
完成新手任务:"Selesaikan tugas pemula",
会员:"anggota",
享受全网最多权益:"Nikmati manfaat maksimal di seluruh jaringan",
社区:"Masyarakat",
在这里发现币圈财富机会:"Temukan peluang kekayaan dalam lingkaran mata uang di sini",
随时随地开启交易:"Mulai berdagang kapan saja, di mana saja",
全面支持:"Dukungan penuh",
和:"Dan",


交割:"Pengiriman",
关于我们:"tentang kami",
账变记录:"Catatan perubahan akun",
股票:"saham",
加密货币:"mata uang kripto",
加载中:"memuat...",
已经全部加载完毕:"Semua telah dimuat",
暂无记录:"Tidak ada catatan",
高级认证:"Sertifikasi lanjutan",
姓名:"Nama",
请输入姓名:"Silakan ketikkan nama Anda",
护照编号:"Nomor paspor",
请输入护照编号:"Silakan masukkan nomor paspor",
护照照片:"pas foto",
申请认证:"Ajukan permohonan sertifikasi",
提示:"petunjuk",
确定:"Tentu",
提交失败:"Pengiriman Gagal",
上传失败:"gagal mengunggah",
身份认证:"Autentikasi",
身份证号:"nomor ID",
请输入身份证号:"Silakan masukkan nomor identifikasi",
身份证照片:"foto tanda pengenal",
申请认证:"Ajukan permohonan sertifikasi",
修改资金密码:"Ubah kata sandi dana",
旧密码:"password lama",
请输入旧密码:"Silakan masukkan kata sandi lama",
新密码:"kata sandi baru",
请输入6位数字:"Silakan masukkan 6 digit",
确认新密码:"Konfirmasikan kata sandi baru",
请再次输入新密码:"Silakan masukkan kata sandi baru lagi",
提交:"kirim",
请输入新密码:"Silakan masukkan kata sandi baru",
请输入6位数新密码:"Silakan masukkan kata sandi 6 digit baru",
请确认两次密码输入一致:"Harap konfirmasi bahwa kedua kata sandi yang dimasukkan konsisten",
修改登录密码:"Ubah kata sandi masuk",
密码长度:"Kata sandi (6-12 karakter)",
密码长度提示:"Silakan masukkan 6-12 karakter, termasuk angka atau huruf",
客服:"pelayanan pelanggan",
永续:"Berkelanjutan",
交割:"Pengiriman",
永续合约:"Kontrak abadi",
交割合约:"Kontrak pengiriman",
全仓:"Gudang penuh",
开多:"Buka lama",
开空:"Buka sebentar",
价格:"harga",
开仓金额:"Jumlah pembukaan",
可用金额:"Jumlah Tersedia",
合约金额:"Jumlah kontrak",
保证金:"batas",
手续费:"Biaya penanganan",
看涨:"bullish",
看跌:"Kasar",
交割时间:"waktu pengiriman",
数量:"kuantitas",
持有仓位:"Tahan posisi",
当前委托:"Pesanan saat ini",
历史订单:"Perintah sejarah",
暂无数据:"Tidak ada data",
购买价:"harga pembelian",
市价: "harga pasar",
限价: "batas harga",
现价:"Harga sekarang",
金额:"Jumlah",
盈亏:"Laba rugi",
操作:"beroperasi",
平仓:"Tutup posisi",
撤单:"Batalkan pesanan",
方向:"arah",
剩余时间:"waktu tersisa",
交割时间:"waktu pengiriman",
详情:"Detail",
名称:"nama",
最新价格:"harga terbaru",
h24涨跌:"24 jam naik turun",
h24涨跌幅:"24 jam bertambah dan berkurang",
请输入开仓金额:"Silakan masukkan jumlah pembukaan",
请输入开仓价格:"Silakan masukkan harga pembukaan",
确定执行撤单操作:"Apakah Anda yakin ingin membatalkan pesanan?",
确定执行平仓操作:"Apakah Anda yakin untuk menjalankan operasi penutupan posisi?",
交割合约历史:"Riwayat kontrak pengiriman",
历史仓位:"Posisi bersejarah",
到期时间:"Tanggal kadaluarsa",
闪兑:"Pertukaran kilat",
从:"dari",
最大:"maksimum",
可用数量:"Kuantitas Tersedia",
至:"ke",
复制成功:"Berhasil disalin",
基金理财:"Pengelolaan keuangan dana",
托管金额:"Jumlah escrow",
总收益:"Total pendapatan",
当日收益:"Pendapatan hari ini",
托管订单:"Pesanan eskrow",
规则:"aturan",
日收益:"Pendapatan harian",
限额:"membatasi",
周期:"siklus",
天:"langit",
立即买入:"Beli sekarang",
购买:"Membeli",
购买日:"Tanggal Pembelian",
起息日:"tanggal nilai",
派息时间:"Waktu pembayaran dividen",
每日:"sehari-hari",
计息结束日:"Tanggal akhir akrual bunga",
提前赎回:"penebusan awal",
预计收益:"Perkiraan pendapatan",
今日日收益:"Hari ini (pendapatan harian)",
最少可投:"Investasi minimal",
最大可投:"Investasi maksimal",
请输入买入金额:"Silakan masukkan jumlah pembelian",
可用金额:"Jumlah Tersedia",
请输入买入金额:"Silakan masukkan jumlah pembelian",
质押金额:"Jumlah janji",
累计收益:"Pendapatan kumulatif",
开始时间:"Waktu mulai",
结束时间:"Akhir waktu",
理财规则:"aturan keuangan",
理财规则1:"Pengelolaan keuangan dilakukan dengan mempercayakan USDT ke platform, dan tim profesional platform melakukan arbitrase keuangan.Peserta dapat memperoleh bagian dari pendapatan pengelolaan keuangan platform selama periode penyimpanan dana.",
收益计算:"Perhitungan pendapatan",
理财规则2:"Jika anggota menyetor 10.000U di platform dan memilih produk keuangan dengan siklus 5 hari dan pendapatan harian 0,3%~0,5%, pendapatan hariannya adalah sebagai berikut：",
最低:"terendah",
最高:"Paling tinggi",
理财规则3:"Keduanya: Anda bisa mendapatkannya setelah 5 hari",
理财规则4:"Pendapatan didistribusikan setiap hari, Pendapatan yang didistribusikan dapat diakses dan ditarik kapan saja dan disetorkan ke pokok, setelah jatuh tempo akan otomatis dikembalikan ke rekening Anda.",
关于违约金:"Tentang ganti rugi yang dilikuidasi",
理财规则5:"Jika Anda ingin mentransfer pokok yang belum habis masa berlakunya, akan dikenakan ganti rugi yang dilikuidasi.",
理财规则6:"Kerusakan yang dilikuidasi = rasio penyelesaian x sisa hari x jumlah investasi.",
理财规则7:"Contoh: Rasio penyelesaian ganti rugi produk ini adalah",
剩余:"Tersisa",
天到期投资:"Masa berlakunya habis dalam beberapa hari, dan jumlah investasinya adalah",
则:"Tetapi",
违约金:"ganti rugi",
实际退还本金为:"Kepala sekolah sebenarnya yang dikembalikan adalah",
现货账户:"akun tempat",
总资产:"Total aset",
充币:"Setor koin",
提币:"Tarik koin",
闪兑:"Pertukaran kilat",
投资组合:"portofolio",
冻结数量:"kuantitas beku",
帮助中心:"Pusat Bantuan",
自选:"Opsional",
行情:"Kutipan",
资金:"dana",
资讯:"Informasi",
我的:"milikku",
交易对:"pasangan perdagangan",
最新价:"Harga terbaru",
成交量:"Volume",
标记价格:"tandai harga",
h24最高价:"Harga tertinggi 24 jam",
h24最低价:"Harga terendah 24 jam",
h24成交量:"Volume perdagangan 24 jam",
h24交易额:"Volume transaksi 24 jam",
分时:"Berbagi waktu",
分1:"1 poin",
分5:"5 poin",
分15:"15 tanda",
分30:"30 poin",
小时1:"1 jam",
天1:"1 hari",
周1:"1 minggu",
月1:"Januari",
委托订单:"Memesan",
最新交易:"Transaksi terkini",
买入:"Membeli",
卖出:"menjual",
时间:"waktu",
方向:"arah",
取消自选成功:"Berhasil membatalkan pilihan",
添加成功:"Berhasil ditambahkan",
登录:"Gabung",
账户:"Akun",
邮箱:"Surat",
手机号:"Nomor telepon",
请输入账户:"Silakan masukkan akun",
请输入邮箱:"silakan masukkan email Anda",
请输入手机号:"Silakan masukkan nomor telepon",
密码:"kata sandi",
请输入密码:"Silakan masukkan kata sandi",
忘记密码:"lupa kata sandinya?",
还没有账号:"Belum ada akun",
去注册:"Pergi untuk mendaftar",
请输入登录账号:"Silakan masukkan akun login Anda",
请输入登录密码:"Silakan masukkan kata sandi Anda",
登录失败:"Gagal masuk",
历史记录:"catatan sejarah",
充值:"isi ulang",
提现:"menarik",
未审核:"Tidak ditinjau",
成功:"kesuksesan",
失败:"gagal",
快捷入口:"Entri cepat",
资金密码:"Kata sandi dana",
登录密码:"kata sandi masuk",
账变记录:"Catatan perubahan akun",
邀请推广:"Undang promosi",
通用:"Universal",
语言:"bahasa",
在线客服:"layanan daring",
身份认证:"Autentikasi",
高级认证:"Sertifikasi lanjutan",
更多:"Lagi",
帮助中心:"Pusat Bantuan",
关于我们:"tentang kami",
退出:"berhenti",
已提交身份认证:"Anda telah mengirimkan informasi identitas Anda dan sedang ditinjau",
您已完成身份认证:"Anda telah menyelesaikan verifikasi identitas",
您已完成高级认证:"Anda telah menyelesaikan Sertifikasi Lanjutan",
确定退出登录:"Apakah Anda yakin ingin logout?",
资讯:"Informasi",
公告:"pengumuman",
状态:"negara",
已成交:"Kesepakatan selesai",
委托金额:"Jumlah komisi",
剩余金额:"keseimbangan",
订单类型:"Jenis pesanan",
市价委托:"tatanan pasar",
限价委托:"membatasi pesanan",
订单号:"jumlah order",
委托时间:"Waktu komisi",
U本位合约历史:"Riwayat kontrak berbasis U",
成交数量:"Jumlah transaksi",
实现盈亏:"Sadarilah untung dan rugi",
推广记录:"Catatan promosi",
我的总推广:"Promosi umum saya",
总充值:"Isi ulang total",
一代人数:"Jumlah generasi",
二代人数:"Jumlah generasi kedua",
三代人数:"Jumlah tiga generasi",
立即推广:"Promosikan sekarang",
我的推广:"promosi saya",
用户名:"nama belakang",
行情:"Kutipan",
加密货币:"mata uang kripto",
外汇:"Valas",
股票:"saham",
现货交易:"Perdagangan Tempat",
热门:"Populer",
涨幅榜:"Daftar pemenang",
跌幅榜:"Daftar pecundang",
快速充币:"Setoran cepat",
保存二维码:"Simpan kode QR",
复制地址:"Salin alamat",
转出地址:"Alamat transfer keluar (opsional)",
请输入转出地址:"Silakan masukkan alamat transfer keluar",
粘贴:"Tempel",
充币数量:"Jumlah setoran",
请输入充币数量:"Silakan masukkan jumlah deposit",
区块链网络:"jaringan blockchain",
付款凭证:"Voucher pembayaran (unggah tangkapan layar rincian pembayaran)",
请输入充值数量:"Silakan masukkan jumlah isi ulang",
充值通道:"Saluran isi ulang",
请选择充值币种:"Silakan pilih mata uang isi ulang",
官方充值通道:"Saluran isi ulang resmi",
设置密码:"mengatur kata sandi",
确认密码:"konfirmasi sandi",
验证码:"Kode verifikasi",
请输入验证码:"silakan masukkan kode verifikasi",
获取验证码:"dapatkan kode verifikasi",
重新发送:"Kirim ulang",
邀请码:"Kode undangan",
请输入邀请码:"Silakan masukkan kode undangan",
我已阅读并同意:"Saya telah membaca dan setuju",
服务条款:"Ketentuan Layanan",
注册:"daftar",
已有账号:"Sudah memiliki akun",
去登录:"Pergi untuk masuk",
请再次输入密码:"Silakan masukkan kata sandi lagi",
请同意服务条款:"Harap setujui persyaratan layanan",
注册失败:"registrasi gagal",
欢迎来到:"Selamat datang di!",
全球最大的区块链资产平台:"Platform aset blockchain terbesar di dunia",
分享二维码:"Bagikan kode QR",
链接分享:"Berbagi tautan",
复制:"menyalin",
您的邀请码:"kode undangan Anda",
到数字币地址:"Ke alamat mata uang digital",
选择币种:"Pilih Mata Uang",
区块链网络:"jaringan blockchain",
提币说明:"Instruksi penarikan",
提现费用:"Biaya penarikan",
可到账数量:"Kuantitas yang tersedia",
可用:"Tersedia",
请输入支付密码:"Silakan masukkan kata sandi pembayaran",
请输入提币数量:"Silakan masukkan jumlah penarikan",
全部:"semua",
支付密码:"Kata sandi pembayaran",
地址:"alamat",
委托价:"Harga pesanan",
成交时间:"Waktu transaksi",
成交金额:"Pergantian",
委托中:"Berdasarkan komisi",
持仓中:"Dalam posisi",
平仓中:"Penutupan posisi",
已平仓:"Posisi ditutup",
开仓倍数:"Membuka banyak",
委托价格:"Harga komisi",
收盘价:"Harga penutup",
收益率:"tingkat pengembalian",
平仓时间:"Waktu tutup",
请输入转换数量:"Silakan masukkan kuantitas konversi",
请上传付款凭证:"Silakan unggah voucher pembayaran",
开盘价:"harga pembukaan",
开市中:"Membuka",
已休市:"Pasar telah ditutup",
美股:"Saham AS",
平仓价:"Harga penutup",
到期结算完成:"Penyelesaian jatuh tempo selesai",
印度股票:"saham India",
马来股票:"Saham Melayu",
结算中:"Penyelesaian",
越南股票:"saham Vietnam",
设置资金密码: "Tetapkan kata sandi dana",
请输入资金密码: "Silakan masukkan kata sandi dana",
取消:"Membatalkan",
确定:"Tentu",
止损价:"Hentikan harga kerugian",
请输入止损价格:"Silakan masukkan harga stop loss",
请输入止盈价格:"Silakan masukkan harga take profit",
止盈价:"Ambil harga untung",
设置止盈止损:"Tetapkan ambil untung dan hentikan kerugian",
请输入关键词:"Silakan masukkan kata kunci",
搜索结果:"Hasil Pencarian",
添加收款方式:"Tambahkan metode pembayaran",
高级认证:"Sertifikasi lanjutan",
历史委托:"komisi sejarah",
选择区域码:"Pilih kode area",
请上传身份证图片:"Silakan unggah gambar kartu identitas Anda",
请上传护照照片:"Silakan unggah foto paspor",
请输入提币地址:"Silakan masukkan alamat penarikan",
设置语言:"pengaturan bahasa",
最低金额: "Jumlah minimal",
购买金额: "harga pembelian",
请输入要搜索的国家名称: "Silakan masukkan nama negara yang ingin Anda cari",
确定执行该操作: "Konfirmasikan untuk melakukan ini?",
历史搜索: "Pencarian sejarah",
现货持仓: "Posisi titik",
永续持仓: "Posisi abadi",
到期结算中: "Menyelesaikan pada saat jatuh tempo",
火花图: "diagram percikan",
计价单位: "unit penjualan",
您拒绝了链接: "Anda menolak tautan tersebut",
连接钱包成功: "Koneksi dompet berhasil",
已断开钱包: "Dompet terputus",
钱包切换成功: "Peralihan dompet berhasil",
请先安装钱包插件: "Silakan instal plug-in dompet terlebih dahulu",
连接钱包: "Hubungkan dompet",
交易: "Berdagang",
确认报价: "Konfirmasikan kutipan",
您将获得: "kamu akan mendapatkan",
兑换自: "Tebus dari",
汇率: "kurs",
返回: "kembali",
兑换: "menukarkan",
消息: "Informação",
身份证反面照片: "Foto do verso da carteira de identidade",
身份证正面照片: "Foto frontal do cartão de identificação",
手持身份证照片: "Foto segurando carteira de identidade",
划转: "transferir",
请输入划转数量: "Por favor insira o valor da transferência(USDT)",
邀请链接: "Link de convite",
资料总览: "Visão geral dos dados",
推广规则: "Regras de promoção",
总邀请人数: "Número total de convidados",
总佣金: "comissão total",
安全绑定: "ligação segura",
规则1: "1.Alamat ini hanya menerima {type}. Harap jangan mentransfer aset non-{type} ke alamat ini, jika tidak, aset tidak akan diambil.",
规则2: "2.Setelah Anda mengisi ulang alamat di atas, Anda harus menunggu node jaringan mengonfirmasi. Setelah node jaringan mengonfirmasi, aset akan otomatis masuk ke akun Anda. Kami akan memberi tahu Anda tentang status kedatangan dalam bentuk pengumuman situs web.",
规则3: "3.Alamat isi ulang Anda tidak akan sering berubah dan Anda dapat mengisi ulang berulang kali; jika ada perubahan, kami akan memberi tahu Anda melalui pengumuman situs web",

安全中心: "Pusat keamanan",
绑定手机号: "Ikat nomor ponsel",
认证中心: "Pusat Sertifikasi",
身份认证: "Autentikasi",
认证要求: "Persyaratan sertifikasi",
政府发行的证件: "Dokumen yang dikeluarkan pemerintah",
功能与限制: "Fitur dan batasan",
无限额: "Tidak ada batas",
预计审核时间: "Perkiraan waktu peninjauan: 60 menit",
开始认证: "Mulai sertifikasi",
充币规则: "Aturan setoran",
加密货币股票多类选择: "Pilihan Berganda Saham Cryptocurrency",
    个人中心: "Pusat pribadi",
    充值记录: "Catatan isi ulang",
    提现记录: "Catatan penarikan"

    
}


// WEBPACK FOOTER //
// ./src/lang/india.js